import { render, staticRenderFns } from "./OnboardChatsPage.vue?vue&type=template&id=b32f8396&scoped=true"
import script from "./OnboardChatsPage.vue?vue&type=script&lang=js"
export * from "./OnboardChatsPage.vue?vue&type=script&lang=js"
import style0 from "./OnboardChatsPage.vue?vue&type=style&index=0&id=b32f8396&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32f8396",
  null
  
)

export default component.exports